<div class="modal-header uploadAvatar">
  <h2 mat-dialog-title>Upload Profile Image</h2>
  <button type="button" class="close-button" mat-dialog-close aria-label="Close modal"><span class="ion-android-close" area-hidden="true"></span></button>
</div>
<mat-dialog-content>
  <div class="uploadImageWrapper">
    @if (data.file && !uploadingNew) {
      <figure [ngClass]="{'userAvatarPreview': true, 'rounded': data.roundCropper}">
        <img [src]='data.file' alt="evaluator's avatar image">
      </figure>
    }
    @if (!data.file) {
      <div class="upload-avatar-drop-area" appDnd (onFileDropped)="dropFile($event)">
        <span class="avatarUpload">
          Drag and drop or
          <label class="fileAttachmentLabel" for="fileAttachmentsUpload_small">browse files</label>
          <input type="file" id="fileAttachmentsUpload_small" class="show-for-sr" (change)="uploadFile($event)" accept="image/*">
          on your computer.
        </span>
        <div class="ion-plus-circled ionicon"></div>
      </div>
    }
    @if (data.file) {
      <image-cropper
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="data.roundCropper"
        [roundCropper]="data.roundCropper"
        [format]="'png'"
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded()"
        (cropperReady)="cropperReady()"
        (loadImageFailed)="loadImageFailed()"
      ></image-cropper>
    }
    @if (data.file) {
      <button
        (click)="removeImage()" class="removeImageButton"
        [ngClass]="{'uploading': uploadingNew}"
        >
        <img src="assets/img/icons/svg/delete_circle_outline.svg" alt="remove image">
      </button>
    }
  </div>


  @if (data.badges.length > 0) {
    <div class="evaluatorBadgeChooser">
      <h3 class="pageHeader">ASSIGN A BADGE</h3>
      <ul class="inlineList">
        @for (badge of data.badges; track badge) {
          <li [ngClass]="{'selectedBadge': data.selectedBadge && data.selectedBadge.requestKey == badge.requestKey}">
            <button (click)="choseBadge(badge)">
              <figure>
                <img src="{{badge.image}}" alt="{{badge.name}}">
                <figcaption>{{badge.name}}</figcaption>
              </figure>
            </button>
            @if (data.selectedBadge && data.selectedBadge.requestKey == badge.requestKey) {
              <button
                (click)="choseBadge(null)" class="removeBadgeButton">
                <img src="assets/img/icons/svg/delete_circle_outline.svg" alt="remove badge">
              </button>
            }
          </li>
        }
      </ul>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button type="button" (click)="cancel()" class="button secondary">Cancel</button>
  <button type="button" (click)="submit()" class="button">Save</button>
</mat-dialog-actions>
